import { defineMessage } from 'services/localization';

export const messages = {
    taxAmountExceedError: defineMessage('tax_amount_cannot_exceed_maxvalue'),
    expenseLineTaxAmountExceedError: defineMessage('expense_line_tax_amount_n_maxdigitscount_digits'),
    expenseOrItemLineAmortizationDateError: defineMessage('amortization_end_date_s_amortization_start_date'),
    itemLineAmountExceedError: defineMessage('item_line_amount_cannot_r_be_less_than_maxvalue'),
    itemLineTaxAmountExceedError: defineMessage('item_line_tax_amount_ca_n_maxdigitscount_digits'),
    inputDefaultPlaceholder: defineMessage('enter_value'),
};
